export enum MultiplePageState {
    SelectAction,
    Scanning,
    Done
}